/*
    Wymagane pliki: cookie-consent.scss, cookie-consent.ts, CookieRenderTagHelper, CookieRenderTagHelper
    Na poziomie strony polityki prywatności: ViewData["CookieConsentSuppress"] = true; (na danej stronie nie 
        wyświetla się cookie-consent url# np <a asp-fragment="cookie-consent">Zmień preferencje cookie</a>)
    Renderowanie fragmentu DOM wykorzystując CookieRenderTagHelper <div cookie="PERMIT_NAME"></div>
*/

import ConsentParams = Gtag.ConsentParams;

const CookieName = "cookie-permits";
export const DefaultPermissions: ConsentParams = {
    'ad_storage': 'denied',
    'analytics_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'functionality_storage': 'denied',
};

const CookiesPermissions = [
    {key: 'basic', name: 'Niezbędne'},
    {key: 'ads', name: 'Reklamowe'},
    {key: 'analytics', name: 'Analityczne'},
    {key: 'func', name: 'Funkcjonalne'}
]

export function initCookieConsent(defaultPermissions: ConsentParams) {
    const confirmButtons = document.querySelectorAll<HTMLButtonElement>("#cookie-consent button[data-cookie-string]");
    confirmButtons.forEach((confirmButton: HTMLButtonElement) => {
        confirmButton.addEventListener("click", confirmButtonClicked, false);
    });

    const adjustButton = document.querySelector<HTMLButtonElement>("#cookie-consent button.adjust-button");
    if (adjustButton instanceof HTMLButtonElement) {
        adjustButton.addEventListener("click", () => {
            console.log('i jest klik')
            const popup = document.querySelector<HTMLElement>(".cookie-popup");
            if (!popup) throw new Error('Could not find popup element');
            popup.classList.add('cookie-details')
        }, false);
    }

    const acc = document.getElementsByClassName("accordion-custom");
    for (let i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function(this: HTMLElement) {
            this.classList.toggle("active");
            const panel = acc[i].querySelector<HTMLElement>('.accordion-panel');
            if (!panel) throw new Error('Panel not found');
            if (panel.style.maxHeight) {
                panel.style.maxHeight = '';
            } else {
                panel.style.maxHeight = panel.scrollHeight + 30 + "px";
            }
        });
    }

    gtag('consent', 'default', defaultPermissions);
    const cookiePermits = getCookie(CookieName);
    if(cookiePermits != null) {
        let perm: ConsentParams = structuredClone(defaultPermissions);
        cookiePermits.split(',').forEach(item => {
            if (item === 'analytics') {
                perm['analytics_storage'] = 'granted'
            } else if (item === 'ads') {
                perm['ad_storage'] = 'granted'
                perm['ad_user_data'] = 'granted'
                perm['ad_personalization'] = 'granted'
            }else if (item === 'func'){
                perm['functional_storage'] = 'granted'
            }
        });
        gtag('consent', 'update', perm);
    }
    initializePermitValues();
}

function initializePermitValues() {
    const confirmInputs= document.querySelectorAll<HTMLInputElement>("#cookie-consent input[data-cookie-permit]");
    const cookiePermits = getCookie(CookieName)?.split(',') ?? [];
    confirmInputs.forEach((input: HTMLInputElement) => {
        if (cookiePermits.some(x => x === input.dataset['cookiePermit']))
            input.checked = true;
    });
}

function confirmButtonClicked(event: MouseEvent) {

    const button = event.currentTarget;
    if (!(button instanceof HTMLElement)) return;

    const cookieAllPermit = button.dataset['cookieAll'] != null;
    const confirmInputs= document.querySelectorAll<HTMLInputElement>("#cookie-consent input[data-cookie-permit]");
    const permits = [...confirmInputs].filter(x => x instanceof HTMLInputElement && (cookieAllPermit || !!x.checked));
    const permitValues = permits.map((x: HTMLElement) => x.dataset['cookiePermit'])
        .filter(x => !!x?.length);
    const expires = getCookieExpireString(button.dataset['cookieString']);

    clearCookies();
    if (button.dataset['cookieString']) {
        document.cookie = button.dataset['cookieString'];
    }
    document.cookie = CookieName + "=" + encodeURIComponent(permitValues.join(',')) + "; expires=" + expires + "; path=/; secure; samesite=none";
    window.location.replace(window.location.href.split('#')[0]);
}

function getCookieExpireString(cookieString: string | undefined) {
    if (!cookieString) return '';
    const expiresRegex = /expires=([^;]+)/;
    const expiresMatch = expiresRegex.exec(cookieString);

    let expiresValue = '';
    if (expiresMatch && expiresMatch.length > 1)
        expiresValue = expiresMatch[1].trim();
    return expiresValue;
}

function getCookie(name: string): string | null {
    const nameLenPlus = (name.length + 1);
    return document.cookie
        .split(';')
        .map(c => c.trim())
        .filter(cookie => {
            return cookie.substring(0, nameLenPlus) === `${name}=`;
        })
        .map(cookie => {
            return decodeURIComponent(cookie.substring(nameLenPlus));
        })[0] || null;
}

function clearCookies() {
    document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
}